import React from "react";
import IconBox from "./IconBox";
import * as Animatable from "react-native-animatable";
import { Box, MainText } from "app/components/common";
import theme from "app/Theme/Theme";

const ResultBox = ({ iconName, legend, name, gain, delay = 0, color }) => {
  return (
    <Animatable.View
      style={{ width: "100%", alignSelf: "center" }}
      animation="fadeInRight"
      delay={delay}
      useNativeDriver
    >
      <Box
        width="100%"
        maxWidth={800}
        backgroundColor="neutral.white"
        borderColor="neutral.transparent.white.80"
        borderRadius={10}
        padding="sm"
        alignItems="center"
        justifyContent="center"
        flexDirection="row"
        marginBottom="sm"
      >
        <IconBox iconName={iconName} />
        <Box
          marginLeft="sm"
          alignItems="flex-start"
          justifyContent="flex-start"
          flexDirection="column"
          flex={1}
        >
          <MainText variant="l3-medium" color="neutral.600">
            {legend}
          </MainText>
          <MainText variant="l5-bold" color="neutral.900">
            {name}
          </MainText>
        </Box>
        <MainText marginRight="xs" variant="l6-bold" style={{ color }}>
          +{gain}
        </MainText>
      </Box>
    </Animatable.View>
  );
};

export default ResultBox;
